module.exports = __webpack_public_path__ + "static/media/cz.09a9b116.svg";